'use server'

import { logger } from '@repo/shared-server/logger'
import { createServerFn } from '@tanstack/react-start'
import { getRequestHeaders } from '@tanstack/react-start/server'
import { auth } from './auth'

export const authUserSession = createServerFn({ method: 'GET' })
  .validator((data: { disableCookieCache?: boolean }) => data)
  .handler(async ({ data }) => {
    try {
      const session = await auth.api.getSession({
        headers: getRequestHeaders(),
        query: {
          disableCookieCache: data?.disableCookieCache ? 'true' : undefined,
        },
      })

      return session
    } catch (error) {
      logger.error(error, 'Error fetching session:')
      return null
    }
  })
